import { coalesceArray } from '../../../utility/arrayHelpers';
import {
    getDateFieldValue,
    getPersonValues,
} from '../../../utility/typedFieldHelpers';
import { getFieldHtml } from '../../../utility/xmlHelpers';
import qRulesNamespaceResolver from './qRulesNamespaceResolver';

function getValueForFieldMapping(fieldItem, nodeMap) {
    const { isParentId, xPath, isRichText, isDate, isPerson } = fieldItem;

    if (isParentId) {
        return nodeMap.parentId;
    }

    if (!xPath) {
        return null;
    }

    const { node: rowNode } = nodeMap;
    const fieldNode = rowNode.selectSingle(xPath);

    if (!fieldNode) {
        console.warn(
            'Failed to map SharePoint field. Could not find node at XPath: ' +
                xPath,
        );

        return null;
    }

    if (isRichText) {
        // .html() doesn't work on XML nodes in IE
        return getFieldHtml(fieldNode.getNode());
    }

    const nodeValue = fieldNode.value();

    if (isDate) {
        const dateValue = getDateFieldValue(nodeValue);

        if (dateValue === '-1') {
            throw new Error(
                'Could not submit to list, invalid date: ' + nodeValue,
            );
        }

        return dateValue;
    }

    if (isPerson) {
        const nodes = rowNode.selectNodes(xPath);

        return getPersonValues(nodes, { namespaces: qRulesNamespaceResolver });
    }

    return nodeValue;
}

const getFieldItem = (nodeMap) => (fieldItem) => {
    const values = coalesceArray(getValueForFieldMapping(fieldItem, nodeMap));
    const isFieldUserValue = fieldItem.isPerson;

    return {
        internalName: fieldItem.sharePointColumn,
        // 53316 - for consistency with return value of list query, renaming this to values and making it an array.
        values,
        isId: fieldItem.isId,
        isFieldUserValue,
        isMultiValue: isFieldUserValue,
        multiValues: isFieldUserValue ? values : null,
        xPath: fieldItem.xPath,
        isDate: fieldItem.isDate,
        isDateTime: fieldItem.isDate,
    };
};

const getMappedItemId = (node, idxPath) => {
    const idNode = idxPath && node.selectSingle(idxPath);
    const nodeIdValue = idNode && idNode.value();
    const nodeIdValueInt = parseInt(nodeIdValue);

    return Number.isNaN(nodeIdValueInt) ? 0 : nodeIdValueInt;
};

export function getItemArray(nodesToMap, mapping, idxPath) {
    const mappingFields = mapping.getFields();

    return nodesToMap.map((node) => {
        const fieldArray = mappingFields.map(getFieldItem(node));

        return {
            Id: getMappedItemId(node.node, idxPath),
            node,
            fieldArray,
        };
    });
}
